// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-j"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 19H13.5C13.7761 19 14 18.7761 14 18.5V5H10.6667","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersJIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-j',
    ref,
    icon: element,
  },
));

LettersJIcon.displayName = 'LettersJIcon';

export default LettersJIcon;
